import { render, staticRenderFns } from "./FundTransfersIcon.vue?vue&type=template&id=49889719&"
import script from "./FundTransfersIcon.vue?vue&type=script&lang=js&"
export * from "./FundTransfersIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49889719')) {
      api.createRecord('49889719', component.options)
    } else {
      api.reload('49889719', component.options)
    }
    module.hot.accept("./FundTransfersIcon.vue?vue&type=template&id=49889719&", function () {
      api.rerender('49889719', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounting/bank/FundTransfersIcon.vue"
export default component.exports